// src/slices/auth/login/thunk.js
import { postLogin } from "../../../helpers/eirna_backend_helper";
import { setAuthorization } from "../../../helpers/api_helper";
import {
  loginSuccess,
  apiError,
  logoutUserSuccess,
  reset_login_flag,
} from "./reducer";

// Login Thunk with localStorage (no pending short code needed)
export const loginUser = (user, history) => async (dispatch) => {
  try {
    const response = await postLogin({
      email: user.email,
      password: user.password,
      recaptcha: user.recaptcha,
    });

    if (response && response.meta?.code === 200) {
      const { authentication_token } = response.response.user || {};

      if (authentication_token) {
        // Store token and user info in localStorage
        localStorage.setItem("authToken", authentication_token);
        localStorage.setItem(
          "authUser",
          JSON.stringify(response.response.user)
        );

        // Set authorization for future requests
        setAuthorization(authentication_token);

        dispatch(loginSuccess(response.response.user));

        // Simple redirect to dashboard
        history("/dashboard");
        return;
      }
    }

    dispatch(apiError({ data: "Login failed. Invalid credentials." }));
  } catch (error) {
    dispatch(apiError({ data: error || "Login failed!" }));
  }
};

// Logout Thunk with localStorage cleanup
export const logoutUser = () => async (dispatch) => {
  try {
    // Clear localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
    localStorage.removeItem("dismissedAlerts");

    // Clear authorization header
    setAuthorization(null);

    dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError({ data: "Logout failed!" }));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  dispatch(reset_login_flag());
};
